import { withDependencies, named } from '@wix/thunderbolt-ioc'
import {
	ViewerModel,
	Experiments,
	ViewerModelSym,
	ExperimentsSymbol,
	SiteFeatureConfigSymbol,
	ServiceProvider,
} from '@wix/thunderbolt-symbols'
import {
	EnvironmentDefinition as definition,
	IEnvironmentServiceConfig,
	IEnvironmentDefinition,
	IEnvironmentService,
} from '@wix/viewer-service-environment/definition'
import { EnvironmentService as impl } from '@wix/viewer-service-environment/implementations'
import type { ServiceFactoryOpts } from '@wix/services-manager/types'
import { name } from './symbols'
import type { EnvironmentServiceSiteConfig } from './types'

export const environmentService = withDependencies(
	[ViewerModelSym, ExperimentsSymbol, named(SiteFeatureConfigSymbol, name)],
	(
		viewerModel: ViewerModel,
		experiments: Experiments,
		siteFeatureConfig: EnvironmentServiceSiteConfig
	): ServiceProvider<
		IEnvironmentDefinition,
		(opts: ServiceFactoryOpts<IEnvironmentServiceConfig>) => IEnvironmentService
	> => {
		const config: IEnvironmentServiceConfig = {
			...siteFeatureConfig,
			editorType: siteFeatureConfig.editorType as IEnvironmentServiceConfig['editorType'],
			requestUrl: viewerModel?.requestUrl,
			experiments,
			isQaMode: viewerModel?.mode.qa,
			viewMode: viewerModel?.viewMode,
			editorName: viewerModel?.site.editorName,
			deviceType: viewerModel?.deviceInfo.deviceClass,
			language: viewerModel?.language?.siteLanguage as IEnvironmentServiceConfig['language'],
		}

		return {
			definition,
			impl,
			config,
			platformConfig: config,
		}
	}
)
